<template>
    <div>
        <v-card-text>
            <v-form @submit.prevent="saveAvaluation" ref="form" :disabled="disableForm">
                <v-row>
                    <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-container>
                            <h3 class="my-5"><v-icon color="green" class="mr-1">mdi-eye</v-icon>Olho Esquerdo:</h3>
                            <v-container class="py-5" style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px">
                                <v-row v-if="isMacroscopicReady">
                                    <v-col 
                                        class="d-flex" 
                                        cols="12" 
                                        sm="4" 
                                        v-for="(macroscopic, key) in macroscopicItems"
                                        :key="key.id"
                                    >
                                        <v-checkbox
                                            dense
                                            v-model="selectedLeftMacroscopicItems"
                                            :label="macroscopic.description"
                                            :value="macroscopic.id"
                                            color="green"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex mb-5" cols="12" sm="12" v-if="selectedLeftMacroscopicItems.includes(11)">
                                        <v-textarea
                                            v-model="macroscopicForm.others_left"
                                            color="green"
                                            :label="$t('descriptions.describe')" 
                                            rows="2"
                                            dense
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-container>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-container>
                            <h3 class="my-5"><v-icon color="green" class="mr-1">mdi-eye</v-icon>Olho Direito:</h3>
                            <v-container class="py-5" style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px">
                                <v-row v-if="isMacroscopicReady">
                                    <v-col 
                                        class="d-flex" 
                                        cols="12" 
                                        sm="4" 
                                        v-for="(macroscopic, key) in macroscopicItems"
                                        :key="key.id"
                                    >
                                        <v-checkbox
                                            dense
                                            v-model="selectedRightMacroscopicItems"
                                            :label="macroscopic.description"
                                            :value="macroscopic.id"
                                            color="green"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex mb-5" cols="12" sm="12" v-if="selectedRightMacroscopicItems.includes(11)">
                                        <v-textarea
                                            v-model="macroscopicForm.others_right"
                                            color="green"
                                            :label="$t('descriptions.describe')" 
                                            rows="2"
                                            dense
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-container>
                    </v-col>
                </v-row>
                
               <div class="buttons">
                    <v-row dense class="buttons-row">
                        <v-btn
                            class="rounded-lg buttons-action-btn"
                            elevation="0"
                            color="#41916b"
                            type="submit"
                            :loading="loading"
                            v-if="!disableForm">
                            <span class="textBtn">{{$t('buttons.save')}}</span>
                        </v-btn>

                        <v-btn
                            v-if="patientData.kind_of_donor_id == '2'"
                            class="rounded-lg buttons-action-btn"
                            elevation="0"
                            color="#89ab9b"
                            @click="$emit('changeTab', 0)">
                            <span class="textBtn">{{$t('buttons.return')}}</span>
                        </v-btn>

                        <BackToGridBtn />
                    </v-row>
                </div>
            </v-form>

        </v-card-text>
    </div>
</template>
  
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
    data() {
        return {
            tab:0,
            dialog: false,
            displayError: {
                display: false,
                message: [],
            },
            dialogDonor:false,
            donor_id: "",
            loading: false,
            options: {},
            macroscopic: [],
            donor:[],
            data:[],
            macroscopic_evaluation: [],
            openButtons: false,
            selected:"",
            message: "",
            snackbar: false,
            snackbar_error: false,
            messageError: "",
            unity: "",
            openModal: false,
            donorButton: true,
            isCreate: true,
            formRules: [
                (v) => !!v || "Este campo é obrigatório",
            ],
            isMacroscopicReady: false,
            macroscopicItems: [],
            selectedRightMacroscopicItems: [],
            selectedLeftMacroscopicItems: [],
            disableForm: false,
            macroscopicForm: {},
        };
    },

    components:{
        BackToGridBtn
    },

    props: {
        pcr_donor_data: Object,
        avaliacaoMacroscopica: Array
    },

    created() {
        axios.get(`/macroscopic_evaluations`).then((response) => { 
            this.macroscopicItems = response.data ? response.data : response.data.data
            this.isMacroscopicReady = true
        }).catch(( ) => { 
            this.isMacroscopicReady = false
        })

    },

    computed: {
        ...mapGetters({
          pcrDonorData: "getPCRDonorData",
          patientData: "getPatientData",
          deathData: "getPCRDeathData",
          donorID: "getDonorId"
        }),
    },

    watch: { 
        'avaliacaoMacroscopica': {
            handler() {  
                this.loadFields();
            },

            immediate: true,
        }, 
    },

    methods: {
        ...mapActions([
          "changeSnackBarData",
        ]),

        loadFields(){ 
            let itemsArray = this.avaliacaoMacroscopica 
            
            if(parseInt(itemsArray[0].donor_id) == parseInt(this.patientData.id)){
                for(let i = 0; i < itemsArray.length; i++){ 
                    if(itemsArray[i].orgon_id == '6'){
                        this.selectedLeftMacroscopicItems.push(parseInt(itemsArray[i].macroscopic_evaluation_id))
                        this.macroscopicForm.others_left = itemsArray[i].macroscopic_evaluation_id == 11 ? itemsArray[i].others : null
                    }else if(itemsArray[i].orgon_id == '7'){
                        this.selectedRightMacroscopicItems.push(parseInt(itemsArray[i].macroscopic_evaluation_id))
                        this.macroscopicForm.others_right = itemsArray[i].macroscopic_evaluation_id == 11 ? itemsArray[i].others : null
                    }
                } 
            }
        },

        saveAvaluation(){
            this.loading = true;
            let array = [];
            let object = {};
            let object2 = {};

            for(let i = 0; i < this.selectedLeftMacroscopicItems.length; i++){
                object.orgon_id = 6
                object.macroscopic_evaluation_id = this.selectedLeftMacroscopicItems[i]
                object.others = this.selectedLeftMacroscopicItems[i] == 11 ? this.macroscopicForm.others_left : null

                array.push(object)

                object = {}
            }

            for(let i = 0; i < this.selectedRightMacroscopicItems.length; i++){
                object2.orgon_id = 7
                object2.macroscopic_evaluation_id = this.selectedRightMacroscopicItems[i]
                object2.others = this.selectedRightMacroscopicItems[i] == 11 ? this.macroscopicForm.others_right : null

                array.push(object2)

                object2 = {}
            }

            let obj = new Object
                obj.macroscopic_evaluation = array
            
            let donor_id = this.patientData.id ? this.patientData.id : this.donorID
            axios.post(`/donor/${donor_id}/macroscopic`, obj).then((response) => {
                this.disableForm = this.patientData.macroscopic_pcr_donor ? false : true
                this.changeSnackBarData({
                    status: true,
                    type: 'success', 
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: 'success',
                    titleIcon: 'mdi-check-circle',
                });
                
                setTimeout(() => {
                    this.loading = false;
                    this.closeSnackBar();

                    this.$emit('disableCaptation', false);

                   if (this.patientData.kind_of_donor_id == 2) {
                        // PCR
                        this.$emit('changeTab', 2);
                        } else {
                        // ME
                        this.$emit('changeTab', 1);
                        }
                    

                }, "2000");
            }).catch((err) => {
                this.loading = false
                this.changeSnackBarData({
                    status: true,
                    type: 'erro', 
                    titleMessage: this.$t('messages.something_went_wrong'),
                    bodyMessage: err.details,
                    cardColor: 'red',
                    titleIcon: 'mdi-close-circle',
                });
                setTimeout(() => {
                    this.closeSnackBar();
                }, 3000);
            });
        },

        closeSnackBar(){
            this.changeSnackBarData({
                status: false,
                type: '', 
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        }
    },

};
</script>
  
<style scoped>

p {
    font-size: 16px; 
}

.d-flex {
    padding: 0 12px;
} 

.v-btn:not(.v-btn--round).v-size--default {
    height: 40px !important;
}

.textBtn {
    font-family: "Poppins";
    color: #ffffff;
}

.create-user-dialog {
    padding: 20px;
}

.buttons {
  display: flex;
  margin-top: 32px;
}

.buttons-row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.buttons-action-btn {
  margin-right: 8px;
}

.buttons-action-btn:last-child {
  margin-right: 0;
}

.textBtn {
  color: #fff;
}

@media (max-width: 768px) {
  .buttons {
    width: 100%;
  }

  .buttons-row {
    flex-direction: column;
    align-items: stretch;
  }

  .buttons-action-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .buttons-action-btn:last-child {
    margin-bottom: 0;
  }
} 
</style>
  